<template>
  <div id="app">
    <div class="wrap full-wrap">
      <div class="main-wrap">
        <section class="main main-archive" v-if="contestInfo">
          <div class="img100">
            <img v-bind:src="$hostUrl + 'TH/php_action/' + contestInfo.contestData.img_url">
          </div>
          <div v-html="contestInfo.contestData.rule" class="text-left" style="padding:20px">
          </div>
          <div v-html="contestInfo.contestData.reward" class="text-left" style="padding:20px">
          </div>

          <div class="loop">

            <article class="post format-quote has-post-thumbnail post_format-post-format-quote" v-if="contestInfo.contestData.status == 1">
              <div class="inner text-left">
                <h2 class="entry-title">ส่งผลงาน</h2>
                <div>โปรดดาวน์โหลดไฟล์ใบสมัคร จากลิงก์ <br/> 
                  <a :href="$hostUrl + 'TH/php_action/' + contestInfo.contestData.url"
                    target="_blank">ดาวน์โหลด</a> กรอกข้อมูล
                  แล้วแนบใบสมัครในแบบฟอร์มด้านล่างด้วยครับ</div>
                <form id="formSendFile" v-on:submit.prevent="createContest" method="POST" class="form-group">
                  <div class="row" style="margin-top:20px">
                    <div class="col-sm-6">
                      <div class="post-content">
                        <p>
                          <input type="text" name="txtName" value size="40" placeholder="ชื่อทีม*" required />
                        </p>
                        <!--
                        <p>
                          <input type="text" name="txtSchoolName" value size="40" placeholder="โรงเรียน*" required />
                        </p>
                        <p>
                          <input type="email" name="txtEmail" value size="40" placeholder="Email*" required />
                        </p>
                        <p>
                          <input type="text" name="txtTel" value size="40" placeholder="เบอร์โทรติดต่อ*" required />
                        </p>
                      -->
                        <div class="row">
                          <div class="col-4">แนบใบสมัคร:</div>
                          <div class="col-8">
                            <input type="file" name="fileReg" id="fileReg" class="form-control-file" required />
                          </div>
                        </div>
                      </div>
                    </div>
                    <div class="col-sm-6">
                      <p>
                        <input type="text" name="txtVDOLink" value size="40" placeholder="ลิงค์วิดีโอผลงาน*" required />
                      </p>
                      <div class="row">


                        <div class="col-12">
                          <h3>หลักฐานการใช้หลักสูตร:</h3>
                        </div>
                        <div class="col-4">ไฟล์ที่ 1:</div>
                        <div class="col-8">
                          <input type="file" name="file1" id="file1" class="form-control-file" required />
                        </div>
                        <div class="col-4">ไฟล์ที่ 2:</div>
                        <div class="col-8">
                          <input type="file" name="file2" id="file2" class="form-control-file" />
                        </div>
                        <div class="col-4">ไฟล์ที่ 3:</div>
                        <div class="col-8">
                          <input type="file" name="file3" id="file3" class="form-control-file" />
                        </div>
                        <div class="col-4">ไฟล์ที่ 4:</div>
                        <div class="col-8">
                          <input type="file" name="file4" id="file4" class="form-control-file" />
                        </div>
                        <div class="col-4">ไฟล์ที่ 5:</div>
                        <div class="col-8">
                          <input type="file" name="file5" id="file5" class="form-control-file" />
                        </div>
                        <div class="col-4">ไฟล์ที่ 6:</div>
                        <div class="col-8">
                          <input type="file" name="file6" id="file6" class="form-control-file" />
                        </div>
                      </div>

                      <p class="form-submit">
                        <input type="hidden" name="action" id="action" class="form-control" value="upload" />
                        <button type="submit" class="btn-gray" :disabled="btnSubmit.btnDisable">{{ btnSubmit.btnText
                        }}</button>
                      </p>
                    </div>
                    <div class="alert alert-danger" v-if="responseMSG !== null">{{ responseMSG }}</div>
                  </div>
                </form>
              </div>
            </article>
          </div>
        </section>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "App",
  data: function () {
    return {
      msg: "Welcome to Your Vue.js App",
      uploadingStat: null,
      responseMSG: null,
      contestInfo: null,
      btnSubmit: { btnDisable: false, btnText: "ส่งผลงาน" }
    };
  },
  mounted: function () {
    this.axios.get(this.$hostUrl + "TH/php_action/contestAPI.php?action=get")
      .then(response => {
        this.contestInfo = response.data;
      })
      .finally(() => {
        console.log(this.contestInfo);
      });
  },
  methods: {
    createContest() {
      this.uploadingStat = 1;
      const form = document.getElementById("formSendFile");
      const formData = new FormData(form);
      this.btnSubmit = { btnDisable: true, btnText: "กำลังอัพโหลด..." };
      this.axios
        .post(
          this.$hostUrl + "TH/php_action/contestAPI.php",
          formData,
          {
            headers: {
              "Content-Type": "multipart/form-data"
            }
          }
        )
        .then(response => {
          console.log(response.data);
          if (
            response.data.dupState
          ) {
            alert(response.data.dupState);
          }
          if (
            response.data.insert_query !== "" &&
            response.data.insert_query !== "success"
          ) {
            alert("ส่งข้อมูลไม่สำเร็จ");
            if(response.data.fileDup){
              alert(response.data.fileDup);
            }

            this.btnSubmit = { btnDisable: false, btnText: "ส่งผลงาน" };
            return false;
          } else {
            alert("ข้อมูลถูกบันทึกเรียบร้อย");
            location.reload();
          }
        });
    }
  }
};
</script>

<style lang="stylus">
#app {
  font-family: Avenir, Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
  margin-top: 60px;
}
</style>
